module.exports = __webpack_public_path__ + "img/hero.99fb6d23.webp";